class RatingHeader extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    this.star = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 17 15" fill="none">
        <g clip-path="url(#clip0_1434_70)">
          <path d="M15.8018 5.77197L11.6455 8.9165L13.1221 14.4399L8.80176 11.1313L4.48145 14.4399L5.95801 8.9165L1.80176 5.77197H6.8877L8.80176 0.439941L10.7158 5.77197H15.8018Z" fill="#789905"/>
        </g>
        <defs>
          <clipPath id="clip0_1434_70">
            <rect width="16" height="14" fill="white" transform="matrix(1 0 0 -1 0.801758 14.4399)"/>
          </clipPath>
        </defs>
      </svg>
    `;

    this.shadowRoot.innerHTML = `
    <style>
      .header-sidebar::part(header) {
        flex-wrap: wrap;
      }
      :host {
        display: flex !important;
        align-items: center;
        justify-content: center;
        gap:16px;
        flex-basis: 100%;
      }
      .text {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0.1px;
      }

      .stars {
        display: flex;
      }

      @media (max-width: 768px) {
        :host([size="desktop"]) {
          display: none !important;
        }
      }
      @media (min-width: 768px) {
        :host([size="mobile"]) {
          display: none !important;
        }
        :host([size="desktop"]) {
          grid-area: logo;
          position: relative;
          right: 275px;
        }
        .text {
          font-size: 14px;
          line-height: 16.8px;
        }
        .text span {
          font-weight: 700;
        }
      }
    </style>
    <div class="content" style="display: contents"></div>
    `;
    this.content = this.shadowRoot.querySelector(".content");
  }

  // Shared across all instances so the stats are fetched only once per page load.
  static ratingPromise = null;

  get store() {
    return this.getAttribute("url").replace("https://", "");
  }

  get size() {
    return this.getAttribute("size") ?? "desktop";
  }

  fetchRating() {
    RatingHeader.ratingPromise ??= fetch(
      `https://api.reviews.io/stats/all?store=${this.store}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (!data.company_review_stats) {
          return null;
        }

        const averageRating = parseFloat(
          data.company_review_stats.average_rating
        ).toFixed(1);
        const totalReviews =
          data.company_review_stats.total_reviews.toLocaleString();
        return { averageRating, totalReviews };
      })
      .catch((error) => {
        console.error(error);
        RatingHeader.ratingPromise = null;
        return null;
      });

    return RatingHeader.ratingPromise;
  }

  async renderRating() {
    const rating = await this.fetchRating();

    if (!rating) {
      return;
    }

    const { averageRating, totalReviews } = rating;

    // Replace (never append) so repeated connectedCallback calls - e.g. when the
    // header sidebar drawer is moved to <body> on open - can't duplicate content.
    this.content.innerHTML = `
      <div class="stars">
        ${this.star.repeat(5)}
      </div>
      <div class="text"><span>${averageRating}</span> mit <span> ${totalReviews} </span> Bewertungen</div>
    `;
  }

  connectedCallback() {
    this.renderRating();
  }
}

customElements.define("rating-header", RatingHeader);
